function TypeSurah({ title }) {
    return (
        <span className='p-2 rounded-xl border-2 border-purple-600 px-5 font-medium text-gray-900 text-center'>
            {title}
        </span>
    )
}

export default TypeSurah;